/**
 * @file
 * Equalize columns on blog blocks.
 */

const $blog = $(
  '.cpl-blog-page-block, .path-taxonomy.section-blog .taxonomy-page, .path-taxonomy.section-tag .taxonomy-page',
  context
);

$blog.once('cpl-blog-equalize').each((index, el) => {
  const $this = $(el);

  $this.find('.views-row').attr('data-equalizer-watch', 'equalize-blog');
  $this.attr({
    'data-equalizer': 'equalize-blog',
    'data-equalize-on': 'small',
  });

  $this.foundation();
});
